import styled from "styled-components";

export const WinningStatus = styled.span`
  color: ${(props) => props.color};
`;
